__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "reporting-app";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("dompurify", "3.4.15", () => (__webpack_require__.e(977).then(() => (() => (__webpack_require__(10358))))));
			register("mobx-react", "7.6.0", () => (Promise.all([__webpack_require__.e(233), __webpack_require__.e(627)]).then(() => (() => (__webpack_require__(96233))))));
			register("mobx", "6.16.1", () => (__webpack_require__.e(812).then(() => (() => (__webpack_require__(64812))))));
			register("moment", "2.31.0", () => (__webpack_require__.e(178).then(() => (() => (__webpack_require__(86178))))));
			register("path-to-regexp", "1.9.0", () => (__webpack_require__.e(340).then(() => (() => (__webpack_require__(44340))))));
			register("powerbi-client", "2.24.1", () => (__webpack_require__.e(425).then(() => (() => (__webpack_require__(56425))))));
			register("react-bootstrap", "0.32.4", () => (Promise.all([__webpack_require__.e(548), __webpack_require__.e(803)]).then(() => (() => (__webpack_require__(80548))))));
			register("react-datepicker", "4.25.0", () => (Promise.all([__webpack_require__.e(899), __webpack_require__.e(385)]).then(() => (() => (__webpack_require__(31899))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(97950))), 1);
			register("react-error-boundary", "3.1.4", () => (__webpack_require__.e(177).then(() => (() => (__webpack_require__(59177))))));
			register("react-muuri", "0.3.0", () => (__webpack_require__.e(749).then(() => (() => (__webpack_require__(74749))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(711), __webpack_require__.e(975)]).then(() => (() => (__webpack_require__(62582))))));
			register("react-router", "5.3.4", () => (Promise.all([__webpack_require__.e(711), __webpack_require__.e(456), __webpack_require__.e(196)]).then(() => (() => (__webpack_require__(18456))))));
			register("react-select", "5.10.2", () => (Promise.all([__webpack_require__.e(584), __webpack_require__.e(983)]).then(() => (() => (__webpack_require__(2364))))));
			register("react-table", "7.8.0", () => (__webpack_require__.e(94).then(() => (() => (__webpack_require__(48713))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(65043))), 1);
			register("universal-cookie", "8.1.2", () => (__webpack_require__.e(750).then(() => (() => (__webpack_require__(34750))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(453).then(() => (() => (__webpack_require__(46453))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};